// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"37":"75741719","156":"097d0179","341":"d04918e4","438":"39bbd81a","706":"f4ffc18f","726":"f4a08d67"}[chunkId] + ".chunk.js";
};